import React, { useState, useEffect, useCallback } from 'react';
import { Table, Button, Drawer, Form, Input, DatePicker, InputNumber, message,Tag } from 'antd';
import '../../../styles/Leaves.css';
import { USERURL, ACCOUNTURL } from "../config/config";
import { toast } from "react-toastify";
import { Fetchdetails } from "../../fetchdetails/fetchdetails";

const Leaves = () => {
  const [leaveDrawerVisible, setLeaveDrawerVisible] = useState(false);
  const [leaveData, setLeaveData] = useState([]);
  const [sickLeaveBalance, setSickLeaveBalance] = useState();
  const [loading, setLoading] = useState(false);
  const userdetails = JSON.parse(localStorage.getItem('userdetails'));
  const candidate_id = userdetails?.candidate_id;

  const [form] = Form.useForm();
  const [errors, setErrors] = useState({ finalmessage: '' });

  const fetchLeaveDetails = useCallback(async () => {
    if (!candidate_id) {
      toast.error('Candidate ID not found');
      return;
    }

    setLoading(true);
    try {
      const token = localStorage.getItem('access_token');
      const api = `${ACCOUNTURL}getcanleavedetails/${candidate_id}`;
      const postData = {
        method: 'get',
        headers: {
          'content-type': 'application/json',
          'authorization': token
        },
      };

      const response = await Fetchdetails(api, postData);

      if (response.actionMsg === 1) {
        const res = response.res;
        if (res.actionMsg === 1) {
          setLeaveData(res.datalist || []);
          setSickLeaveBalance(res.leavecount || 0);
        }
      } else {
        toast.error('Failed to fetch leave details');
      }
    } catch (error) {
      toast.error(error.message || 'Error fetching leave details');
    } finally {
      setLoading(false);
    }
  }, [candidate_id]);

  useEffect(() => {
    fetchLeaveDetails();
  }, [fetchLeaveDetails]);

  const showDrawer = () => {
    setLeaveDrawerVisible(true);
  };

  const closeDrawer = () => {
    form.resetFields();
    setLeaveDrawerVisible(false);
    setErrors({ finalmessage: '' });
  };

  const validateLeaveHours = (_, value) => {
    if (value > sickLeaveBalance) {
      return Promise.reject(`You only have ${sickLeaveBalance} hours remaining`);
    }
    return Promise.resolve();
  };

  //console.log(candidateId, "candidateIdcandidateIdcandidateIdcandidateId");


  const onFinish = async (values) => {
    if (sickLeaveBalance <= 0) {
      message.error('No sick leaves remaining');
      return;
    }

    try {
      const token = localStorage.getItem('access_token');
      const datastring = {
        candidate_id: candidate_id,
        key: leaveData.length + 1,
        date1: values.date.format('YYYY-MM-DD'),
        leave: values.hours,
        leavecount: sickLeaveBalance,
        reason: values.reason,
      };
      alert(JSON.stringify(datastring))
      const api = `${ACCOUNTURL}insertcanleave`;
      const postData = {
        method: 'post',
        headers: {
          'content-type': 'application/json',
          'authorization': token
        },
        body: JSON.stringify(datastring)
      };

      const response = await Fetchdetails(api, postData);

      if (response.actionMsg === 1) {
        const res = response.res;
        if (res.actionMsg === 0) {
          setErrors(prev => ({ ...prev, finalmessage: res.Message }));
        } else {
          toast.success(res.Message || 'Leave applied successfully');
          closeDrawer();
          setSickLeaveBalance(prev => prev - values.hours);
          await fetchLeaveDetails();
        }
      } else {
        toast.error(response.Message || 'Failed to apply leave');
      }
    } catch (error) {
      toast.error(error.message || 'Error applying leave');
    }
  };

  const columns = [
    {
      title: 'Date',
      dataIndex: 'date',
      key: 'date',
    },
    {
      title: 'Hours',
      dataIndex: 'hours',
      key: 'hours',
    },
    {
      title: 'Reason',
      dataIndex: 'reason',
      key: 'reason',
    },
    {
      title : 'Approval Status',
      dataIndex : 'is_approve',
      key : 'is_approve',
      render : (data) => {
        return(
          <>
            {
            (data.is_approve === '' || data.is_approve === null || data.is_approve === 'no')
            ?
            <Tag color="red">Waiting for Approval</Tag>
            :
            <Tag color="green">Approved</Tag>
          } 
          </>
        )
      }
    }
  ];

  return (
    <>
      <title>Leave Management</title>
      <div className="leave-container">
      <h2>Leave Management</h2>

      <div className="leave-header">
        <div className="leave-balance-card">
          <p>Sick Leave Remaining</p>
          <div className="balance-number">{sickLeaveBalance} hours</div>
        </div>
        <Button type="primary" onClick={showDrawer} className="apply-btn">
          Apply Leave
        </Button>
      </div>

      <div className='leave-table'>
        <Table
          columns={columns}
          dataSource={leaveData}
          pagination={false}
          className="leave-table"
          loading={loading}
          rowKey="key"
        />
      </div>

      <Drawer
        title="Apply Sick Leave"
        placement="right"
        onClose={closeDrawer}
        visible={leaveDrawerVisible}
        width={500}
        destroyOnClose
      >
        <Form form={form} layout="vertical" onFinish={onFinish}>
          <Form.Item
            name="date"
            label="Date"
            rules={[{ required: true, message: 'Please select a date' }]}
          >
            <DatePicker style={{ width: '100%' }} />
          </Form.Item>
          <Form.Item
            name="hours"
            label="Hours"
            rules={[
              { required: true, message: 'Please enter number of hours' },
              { validator: validateLeaveHours }
            ]}
          >
            <InputNumber
              min={1}
              max={8}
              style={{ width: '100%' }}
              placeholder={`Max ${sickLeaveBalance} hours available`}
            />
          </Form.Item>
          <Form.Item
            name="reason"
            label="Reason"
            rules={[{ required: true, message: 'Please provide a reason' }]}
          >
            <Input.TextArea rows={3} />
          </Form.Item>
          {errors.finalmessage && (
            <div style={{ color: 'red', marginBottom: 16 }}>
              {errors.finalmessage}
            </div>
          )}
          <Form.Item>
            <Button type="primary" htmlType="submit" block>
              Submit Leave
            </Button>
          </Form.Item>
        </Form>
      </Drawer>
    </div>
    </>
    
  );
};

export default Leaves;